import React from 'react'
import { ThemeContext } from 'styled-components'
import { isButtonPreset, buttonPresets } from './Button.preset'
import { ButtonProps } from './Button.props'

export default function Button({
  preset = 'filled',
  size,
  variant,

  RightIcon,
  rightIconStyle,

  LeftIcon,
  leftIconStyle,

  disabled,
  text,
  ...rest
}: ButtonProps) {
  const theme = React.useContext(ThemeContext)
  const currentPreset = isButtonPreset(preset)
    ? buttonPresets[preset]
    : buttonPresets.filled
  const Button = currentPreset[variant]
  const RIGHT_ICON_STYLE = currentPreset.rightIcon(
    theme,
    disabled,
    rightIconStyle
  )
  const LEFT_ICON_STYLE = currentPreset.leftIcon(theme, disabled, leftIconStyle)
  return (
    <Button {...rest} size={size} disabled={disabled}>
      {LeftIcon && <LeftIcon style={LEFT_ICON_STYLE} />}
      {text}
      {RightIcon && <RightIcon style={RIGHT_ICON_STYLE} />}
    </Button>
  )
}
